import { securedAxiosInstance } from "@/api/axios";
import { toCamelCase, toSnakeCase } from "@estaly/ui/src/utils/data_formatter";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setIndex(state, data) {
      state.index = data.records;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, { keywords, page, includes } = {}) {
      const response = await securedAxiosInstance.get("/merchant_profiles", {
        params: toSnakeCase({ keywords, page, includes }),
      });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
    async delete(_, id) {
      const response = await securedAxiosInstance.delete(`/merchant_profiles/${id}`);
      return response?.success;
    },
    async update(_, params) {
      const { id, ...data } = params;
      const response = await securedAxiosInstance.put(`/merchant_profiles/${id}`, {
        merchant_profile: toSnakeCase(data),
      });
      return response?.success;
    },
    async new() {
      const response = await securedAxiosInstance.get("/merchant_profiles/new");
      return response?.success ? toCamelCase(response.data) : null;
    },
    async create(_, params) {
      const response = await securedAxiosInstance.post("/merchant_profiles", {
        merchant_profile: toSnakeCase(params),
      });
      return response?.success;
    },
  },
};
